module.exports = __webpack_public_path__ + "img/vocational-guidance.a6c4feda.svg";